<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
      :savoynet="imovel.savoynet"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">Status</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs2>
        <v-container fluid class="py-2">
          <v-layout row wrap>
            <v-flex xs12 v-if="canEditStatus">
              <v-btn flat @click.stop="onSubmit" :disabled="isFormInvalid">
                <span class="subtitulo">Salvar</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <form v-on:submit.prevent="onSubmit">
      <v-layout row wrap class="pt-5 readonly-form" :class="{ 'readonly-form--blocked': !canEditStatus }">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
          <v-container fluid>
            <v-layout row wrap class="mt-3">

              <!-- LISTA DE STATUS -->
              <v-flex xs12>
                <v-select
                  v-model="form.fields.status"
                  v-bind:items="listaStatus"
                  v-validate="'required'"
                  name="status"
                  data-vv-as="status"
                  :error-messages="errors.has('status') ? errors.first('status') : []"
                  label="Selecione um status"
                >
                </v-select>
              </v-flex>

              <!-- CAMPOS: VAGO -->
              <transition name="slide-x-transition">
                <div style="width: 100%;" v-if="form.fields.status === 'Vago'">
                  <v-flex xs12 class="switch-fix mb-5">
                    <strong><span v-if="form.fields.vago_com_placa">Com</span><span v-else>Sem</span> placa</strong>
                    <v-switch
                      v-model="form.fields.vago_com_placa" 
                      color="secondary"
                      hide-details
                    >
                    </v-switch>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="form.fields.vago_seguranca"
                      v-bind:items="listaSeguranca"
                      name="vago_seguranca"
                      label="Nível de segurança"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12>              
                    <v-text-field
                      v-model="form.fields.vago_seguranca_observacoes"
                      label="Observações de segurança"
                      name="vago_seguranca_observacoes"
                    >
                    </v-text-field>
                  </v-flex>
                </div>
              </transition>

              <!-- CAMPOS: COMPROMISSADO -->
              <transition name="slide-x-transition">
                <div style="width: 100%;" v-if="form.fields.status === 'Compromissado'">
                  <v-flex xs12>
                    <v-select
                      v-model="form.fields.compromissado_condicao"
                      v-bind:items="listaCondicao"
                      name="compromissado_condicao"
                      label="Condição"
                    >
                    </v-select>
                  </v-flex>
                  <transition name="slide-x-transition">
                    <div style="width: 100%;" v-if="form.fields.compromissado_condicao === 'Inadimplente'">
                      <v-flex xs12>
                        <v-menu
                          lazy
                          v-model="compromissadoInadimplenteDataMenu"
                          transition="scale-transition"
                          offset-y
                          full-width
                          :nudge-top="400"
                          :nudge-left="40"
                          max-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            prepend-icon="today"
                            v-model="form.fields.compromissado_inadimplente_data_formatada"
                            label="Data da inadimplência"
                            readonly
                          >
                          </v-text-field>
                          <v-date-picker
                            v-model="form.fields.compromissado_inadimplente_data"
                            locale="pt-br"
                            autosave
                            :date-format="date => new Date(date).toLocaleDateString()"
                            :formatted-value.sync="form.fields.compromissado_inadimplente_data_formatada"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                    </div>
                  </transition>
                  <transition name="slide-x-transition">
                    <div style="width: 100%;" v-if="form.fields.compromissado_condicao === 'Inadimplente ajuizado'">
                      <v-flex xs12>
                        <v-text-field
                          v-model="form.fields.compromissado_ajuizado_cliente"
                          label="Nº do cliente/caso"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="form.fields.compromissado_ajuizado_processo"
                          label="Nº do processo/execução"
                        >
                        </v-text-field>
                      </v-flex>
                    </div>
                  </transition>
                  <v-flex xs12>              
                    <v-text-field
                      v-model="form.fields.compromissado_comprador"
                      label="Nome do comprador"
                      name="compromissado_comprador"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-menu
                      lazy
                      v-model="compromissadoDataMenu"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-top="400"
                      :nudge-left="40"
                      max-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        prepend-icon="today"
                        v-model="form.fields.compromissado_data_formatada"
                        label="Data do compromisso"
                        readonly
                      >
                      </v-text-field>
                      <v-date-picker
                        v-model="form.fields.compromissado_data"
                        locale="pt-br"
                        autosave
                        :date-format="date => new Date(date).toLocaleDateString()"
                        :formatted-value.sync="form.fields.compromissado_data_formatada"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                </div>
              </transition>

              <!-- CAMPOS: LOCADO -->
              <transition name="slide-x-transition">
                <div style="width: 100%;" v-if="form.fields.status === 'Locado'">
                  <v-flex xs12>
                    <v-select
                      v-model="form.fields.locado_condicao"
                      v-bind:items="listaCondicao"
                      name="locado_condicao"
                      label="Condição"
                    >
                    </v-select>
                  </v-flex>
                  <transition name="slide-x-transition">
                    <div style="width: 100%;" v-if="form.fields.locado_condicao === 'Inadimplente'">
                      <v-flex xs12>
                        <v-menu
                          lazy
                          v-model="locadoInadimplenteDataMenu"
                          transition="scale-transition"
                          offset-y
                          full-width
                          :nudge-top="400"
                          :nudge-left="40"
                          max-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            prepend-icon="today"
                            v-model="form.fields.locado_inadimplente_data_formatada"
                            label="Data da inadimplência"
                            readonly
                          >
                          </v-text-field>
                          <v-date-picker
                            v-model="form.fields.locado_inadimplente_data"
                            locale="pt-br"
                            autosave
                            :date-format="date => new Date(date).toLocaleDateString()"
                            :formatted-value.sync="form.fields.locado_inadimplente_data_formatada"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                    </div>
                  </transition>
                  <transition name="slide-x-transition">
                    <div style="width: 100%;" v-if="form.fields.locado_condicao === 'Inadimplente ajuizado'">
                      <v-flex xs12>
                        <v-text-field
                          v-model="form.fields.locado_ajuizado_cliente"
                          label="Nº do cliente/caso"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="form.fields.locado_ajuizado_processo"
                          label="Nº do processo/execução"
                        >
                        </v-text-field>
                      </v-flex>
                    </div>
                  </transition>
                  <v-flex xs12>
                    <v-text-field
                      v-model="form.fields.locado_locador"
                      label="Nome do locador"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="form.fields.locado_locatario"
                      label="Nome do locatário"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>              
                    <v-text-field
                      v-model="form.fields.locado_valor"
                      label="Valor do aluguel"
                      name="locado_valor"
                      v-money="'money'"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-menu
                      lazy
                      v-model="locadoValorDataMenu"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-top="400"
                      :nudge-left="40"
                      max-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        prepend-icon="today"
                        v-model="form.fields.locado_valor_data_formatada"
                        label="Data do valor do aluguel"
                        readonly
                      >
                      </v-text-field>
                      <v-date-picker
                        v-model="form.fields.locado_valor_data"
                        locale="pt-br"
                        autosave
                        :date-format="date => new Date(date).toLocaleDateString()"
                        :formatted-value.sync="form.fields.locado_valor_data_formatada"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-menu
                      lazy
                      v-model="locadoInicioDataMenu"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-top="400"
                      :nudge-left="40"
                      max-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        prepend-icon="today"
                        v-model="form.fields.locado_inicio_data_formatada"
                        label="Data do início do contrato"
                        readonly
                      >
                      </v-text-field>
                      <v-date-picker
                        v-model="form.fields.locado_inicio_data"
                        locale="pt-br"
                        autosave
                        :date-format="date => new Date(date).toLocaleDateString()"
                        :formatted-value.sync="form.fields.locado_inicio_data_formatada"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-menu
                      lazy
                      v-model="locadoFimDataMenu"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-top="400"
                      :nudge-left="40"
                      max-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        prepend-icon="today"
                        v-model="form.fields.locado_fim_data_formatada"
                        label="Data do fim do contrato"
                        readonly
                      >
                      </v-text-field>
                      <v-date-picker
                        v-model="form.fields.locado_fim_data"
                        locale="pt-br"
                        autosave
                        :date-format="date => new Date(date).toLocaleDateString()"
                        :formatted-value.sync="form.fields.locado_fim_data_formatada"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 class="switch-fix mb-5">
                    <strong>Ação renovatória</strong>
                    <v-switch
                      v-model="form.fields.locado_acao_renovatoria" 
                      color="secondary"
                      hide-details
                    >
                    </v-switch>
                  </v-flex>
                  <transition name="slide-x-transition">
                    <div style="width: 100%;" v-if="form.fields.locado_acao_renovatoria">
                      <v-flex xs12>              
                        <v-text-field
                          v-model="form.fields.locado_acao_renovatoria_numero"
                          label="Nº da ação renovatória"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="form.fields.locado_acao_renovatoria_cliente"
                          label="Nº do cliente/caso"
                        >
                        </v-text-field>
                      </v-flex>
                    </div>
                  </transition>
                </div>
              </transition>
              
              <!-- CAMPOS: COMODATO -->
              <transition name="slide-x-transition">
                <div style="width: 100%;" v-if="form.fields.status === 'Comodato'">
                  <v-flex xs12>              
                    <v-text-field
                      v-model="form.fields.comodato_nome"
                      label="Nome"
                      name="comodato_nome"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>              
                    <v-text-field
                      v-model="form.fields.comodato_rg"
                      label="RG"
                      name="comodato_rg"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>              
                    <v-text-field
                      v-model="form.fields.comodato_cpf"
                      label="CPF"
                      name="comodato_cpf"
                      v-mask="'###.###.###-##'"
                      v-validate="{ regex: /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/ }"
                      data-vv-delay="300"
                      data-vv-as="CPF"
                      :error-messages="errors.has('comodato_cpf') ? errors.first('comodato_cpf') : []"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 v-for="(item, index) in form.fields.comodato_telefone" :key="index">              
                    <v-text-field
                      v-model="form.fields.comodato_telefone[index].numero"
                      prepend-icon="phone"
                      v-bind:append-icon="appendIcon(index)"
                      :append-icon-cb="adicionarRemoverTelefone.bind(this, index, form.fields.comodato_telefone)"
                      label="Telefone"
                      name="comodato_telefone"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                    >
                    </v-text-field>
                  </v-flex>
                </div>
              </transition>

              <!-- CAMPOS: INVADIDO -->
              <transition name="slide-x-transition">
                <div style="width: 100%;" v-if="form.fields.status === 'Invadido'">
                  <v-flex xs12>              
                    <v-text-field
                      v-model="form.fields.invadido_nome"
                      label="Nome"
                      name="invadido_nome"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>              
                    <v-text-field
                      v-model="form.fields.invadido_rg"
                      label="RG"
                      name="invadido_rg"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>              
                    <v-text-field
                      v-model="form.fields.invadido_cpf"
                      label="CPF"
                      name="invadido_cpf"
                      v-mask="'###.###.###-##'"
                      v-validate="{ regex: /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/ }"
                      data-vv-delay="300"
                      data-vv-as="CPF"
                      :error-messages="errors.has('invadido_cpf') ? errors.first('invadido_cpf') : []"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 v-for="(item, index) in form.fields.invadido_telefone" :key="index">              
                    <v-text-field
                      v-model="form.fields.invadido_telefone[index].numero"
                      prepend-icon="phone"
                      v-bind:append-icon="appendIcon(index)"
                      :append-icon-cb="adicionarRemoverTelefone.bind(this, index, form.fields.invadido_telefone)"
                      label="Telefone"
                      name="invadido_telefone"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-menu
                      lazy
                      v-model="invadidoDataMenu"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-top="400"
                      :nudge-left="40"
                      max-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        prepend-icon="today"
                        v-model="form.fields.invadido_data_formatada"
                        label="Data estimada da invasão"
                        readonly
                      >
                      </v-text-field>
                      <v-date-picker
                        v-model="form.fields.invadido_data"
                        locale="pt-br"
                        autosave
                        :date-format="date => new Date(date).toLocaleDateString()"
                        :formatted-value.sync="form.fields.invadido_data_formatada"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="form.fields.invadido_condicao"
                      v-bind:items="listaCondicao"
                      name="invadido_condicao"
                      label="Condição"
                    >
                    </v-select>
                  </v-flex>
                  <transition name="slide-x-transition">
                    <div style="width: 100%;" v-if="form.fields.invadido_condicao === 'Ocupado ajuizado'">
                      <v-flex xs12>
                        <v-text-field
                          v-model="form.fields.invadido_ajuizado_cliente"
                          label="Nº do cliente/caso"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="form.fields.invadido_ajuizado_processo"
                          label="Nº do processo/execução"
                        >
                        </v-text-field>
                      </v-flex>
                    </div>
                  </transition>
                </div>
              </transition>

            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </form>
    <ButtonsObservacoesAnexos></ButtonsObservacoesAnexos>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import HeadersDetalhesResumo from '../Headers/HeadersDetalhesResumo'
  import ButtonsObservacoesAnexos from './ButtonsObservacoesAnexos'
  import moment from 'moment'
  import AwesomeMask from 'awesome-mask'
  import currencyFormatter from 'currency-formatter'
  import moneyOptions from '@/moneyOptions'
  
  export default {
    components: {
      HeadersDetalhesResumo,
      ButtonsObservacoesAnexos
    },
    directives: {
      'money': AwesomeMask
    },
    data () {
      return {
        compromissadoDataMenu: false,
        compromissadoInadimplenteDataMenu: false,
        locadoValorDataMenu: false,
        locadoInicioDataMenu: false,
        locadoFimDataMenu: false,
        locadoInadimplenteDataMenu: false,
        invadidoDataMenu: false,
        listaStatus: ['Vago', 'Compromissado', 'Locado', 'Comodato', 'Invadido'],
        listaSeguranca: ['Seguro', 'Média segurança', 'Inseguro'],
        form: {
          fields: {
            status: null,
            vago_com_placa: false,
            vago_seguranca: null,
            vago_seguranca_observacoes: null,
            compromissado_condicao: null,
            compromissado_comprador: null,
            compromissado_data: null,
            compromissado_data_formatada: null,
            compromissado_inadimplente_data: null,
            compromissado_inadimplente_data_formatada: null,
            compromissado_ajuizado_cliente: null,
            compromissado_ajuizado_processo: null,
            locado_condicao: null,
            locado_locador: null,
            locado_locatario: null,
            locado_valor: null,
            locado_valor_data: null,
            locado_valor_data_formatada: null,
            locado_inicio_data: null,
            locado_inicio_data_formatada: null,
            locado_fim_data: null,
            locado_fim_data_formatada: null,
            locado_acao_renovatoria: null,
            locado_acao_renovatoria_numero: null,
            locado_acao_renovatoria_cliente: null,
            locado_inadimplente_data: null,
            locado_inadimplente_data_formatada: null,
            locado_ajuizado_cliente: null,
            locado_ajuizado_processo: null,
            comodato_nome: null,
            comodato_rg: null,
            comodato_cpf: null,
            comodato_telefone: [{ numero: '' }],
            invadido_condicao: null,
            invadido_nome: null,
            invadido_rg: null,
            invadido_cpf: null,
            invadido_telefone: [{ numero: '' }],
            invadido_data: null,
            invadido_data_formatada: null,
            invadido_ajuizado_cliente: null,
            invadido_ajuizado_processo: null
          }
        }
      }
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      canViewStatus () {
        return this.$hasGranularPermission('status', 'view')
      },
      canEditStatus () {
        return this.$hasGranularPermission('status', 'edit')
      },
      listaCondicao () {
        let listaCondicao = []

        switch (this.form.fields.status) {
          case 'Compromissado':
            listaCondicao = ['Em dia', 'Quitado sem escritura', 'Com escritura definitiva', 'Inadimplente', 'Inadimplente ajuizado']
            break
          case 'Locado':
            listaCondicao = ['Em dia', 'Inadimplente', 'Inadimplente ajuizado']
            break
          case 'Invadido':
            listaCondicao = ['Ocupado irregularmente', 'Ocupado ajuizado']
            break
        }

        return listaCondicao
      },
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    watch: {
      imovel () {
        if (this.imovel.hasOwnProperty('status')) {
          const imovelStatus = Object.assign({}, this.imovel.status.data)
          Object.keys(imovelStatus).forEach((key) => (imovelStatus[key] == null) && delete imovelStatus[key])

          if (imovelStatus.locado_valor) {
            imovelStatus.locado_valor = currencyFormatter.format(imovelStatus.locado_valor, moneyOptions)
          }

          Object.keys(imovelStatus).forEach((key) => {
            if (/.*_data$/.test(key)) {
              imovelStatus[key] = moment(imovelStatus[key]).format('YYYY-MM-DD')
              imovelStatus[key + '_formatada'] = moment(imovelStatus[key]).format('DD/MM/YYYY')
            }
            if (/.*_telefone$/.test(key)) {
              if (imovelStatus[key].length < 1) {
                imovelStatus[key] = [{ numero: '' }]
              }
            }
          })

          Object.assign(this.form.fields, imovelStatus)
        }
      }
    },
    methods: {
      appendIcon (index) {
        if (!this.canEditStatus) return null
        if (index === 0) {
          return 'add_circle'
        } else {
          return 'remove_circle_outline'
        }
      },
      adicionarRemoverTelefone (index, fields) {
        if (!this.canEditStatus) return
        if (index === 0) {
          fields.push({ numero: '' })
        } else {
          fields.splice(index, 1)
        }
      },
      onSubmit () {
        if (!this.canEditStatus) return
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            const formattedFields = Object.assign({}, this.form.fields)

            formattedFields.locado_valor = currencyFormatter.unformat(formattedFields.locado_valor, moneyOptions)

            const comodatoTelefone = formattedFields.comodato_telefone.filter((telefone) => {
              return telefone.numero.length > 0
            })
            const invadidoTelefone = formattedFields.invadido_telefone.filter((telefone) => {
              return telefone.numero.length > 0
            })
            formattedFields.comodato_telefone = JSON.stringify(comodatoTelefone)
            formattedFields.invadido_telefone = JSON.stringify(invadidoTelefone)

            axios.patch(`${apiURL}/imoveis/${this.$route.params.id}`, { status: formattedFields }).then((response) => {
              this.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } })
              this.$store.dispatch('utils/hideLoading')
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DetalhesStatus.vue?0001fc6a